module.exports = {"TXTINS_Next":{"id":"TXTINS_Next","defaultMessage":"Weiter","track":"Next"}}